import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useEffect } from 'react';
var useMediaQuery = function useMediaQuery(queries, values, defaultValue) {
  var mediaQueryLists = queries.map(function (q) {
    return window.matchMedia(q);
  });
  var getValue = function getValue() {
    var index = mediaQueryLists.findIndex(function (mql) {
      return mql.matches;
    });
    return values && values[index] || defaultValue;
  };
  var _useState = useState(getValue),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  useEffect(function () {
    var handler = function handler() {
      return setValue(getValue);
    };
    mediaQueryLists.forEach(function (mql) {
      return mql.addEventListener("change", handler);
    });
    return function () {
      return mediaQueryLists.forEach(function (mql) {
        return mql.removeEventListener("change", handler);
      });
    };
  }, []);
  return value;
};
export { useMediaQuery as default };